import config from "../../config";
import { useAuth } from "../../contexts/AuthContext";
import { useVisibleApps } from "../../screens/Apps";
import { canSearch } from "../../utils/search";

// The sidebar's items for this user. Mirrors the route rules in Routes.js.
export function useNavItems() {
  const { apiUser, hasFeature } = useAuth();
  const hasApps = useVisibleApps().length > 0;
  const sidekick = !!apiUser?.has_sidekick;
  // sidekick_configured means iPECS call recording is set up
  const calls = sidekick && !!apiUser?.sidekick_configured;
  const main = [];
  const admin = [];

  if (sidekick) {
    main.push({ to: "/meetings", label: "Meetings", icon: "meetings" });
  }

  if (calls) {
    main.push({ to: "/calls", label: "iPECS calls", icon: "phone" });

    if (apiUser.is_admin || hasFeature(["sidekick_supervisor"])) {
      main.push({ to: "/leaderboard", label: "Leaderboard", icon: "trophy" });
    }
    if (config.dashboard_enabled) {
      main.push({ to: "/dashboard", label: "Dashboard", icon: "insights" });
    }
  }

  // A product of its own, not an admin page, so it sits with the main items
  if (apiUser?.has_moh) {
    main.push({ to: "/admin/moh", label: "Music on hold", icon: "music" });
  }

  if (sidekick && hasApps)
    main.push({ to: "/apps", label: "Apps", icon: "apps" });

  if (sidekick && apiUser.is_admin) {
    admin.push(
      { to: "/admin/users", label: "Users" },
      { to: "/admin/teams", label: "Teams" },
      { to: "/admin/sidekick-settings", label: "Sidekick settings" },
    );
    if (!calls) {
      admin.push({
        to: "/admin/call-recording",
        label: "iPECS call recording",
      });
    }
  }

  const search = sidekick && canSearch(apiUser);

  return { main, admin, sidekick, calls, search };
}
